import { findIndex } from "lodash"
import {
  P2,
  P20,
  TUBE,
  P200,
  P1000,
  TRASH,
  GLASS_TUBE,
  PLUNGER_TOOLTIP_TYPE,
} from  '@learningblocks/storybook-components/lib/PhotosynthesisComponents/MicroPipette/MicroPipette.constants';


const templateState = {	
  id: -1,	
  type: null,	
  volume: 0,	
  minVol: 0,	
  maxVol: 100,	
  volChange: 1,	
  solution: null,	
  solutionAlias: null,	
  tipAttached: false,	
  tipUsed: false,	
  prevSolution: null,
  controlsVisible: false,	
  held: false,	
  imgPath: "",	
  plungerPosition: "At Rest",	
  animatingOut: true,	
  currentPlungerPos: 0,	
  description: "",	

  hasTip: false,
  showVolumeModal: false,
  contactElement: [],
  mixed: false,
  plungerTooltip: PLUNGER_TOOLTIP_TYPE.STOPPER,
};

export function PipetteReducer(state = { pipettes: [] }, action) {
  let currentPipette;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
      return state;
  }

  if (action.type !== "CREATE_PIPETTE" && !action.type.includes("@redux")) {
      if(action.payload.hasOwnProperty("id")){
          if(state.protocolSection.scene.apparatus.hasOwnProperty("pipettes")){
            currentPipette = state.protocolSection.scene.apparatus.pipettes[findIndex(state.protocolSection.scene.apparatus.pipettes, { id: action.payload.id })]
          }
      }
  }

    switch (action.type) {

      case 'CREATE_PIPETTE':

        //Create new obj from template state
        let newObj = { ...templateState, ...action.payload.props }

        if(protocolSection.scene.apparatus.hasOwnProperty("pipettes")){
          protocolSection.scene.apparatus.pipettes = [ ...protocolSection.scene.apparatus.pipettes, newObj ]
        } else {
          protocolSection.scene.apparatus.pipettes = [newObj]
        }

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'TOGGLE_VOLUME_MODAL':
        currentPipette.showVolumeModal = !currentPipette.showVolumeModal;
        protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette
        return { ...state, ...{
             protocolSection: protocolSection
           } }

      case 'REMOVE_TIP':
        currentPipette.hasTip = false;
        protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette
        return { ...state, ...{
             protocolSection: protocolSection
           } }

      case 'TOGGLE_PLUNGER_TOOLTIP':
        currentPipette.plungerTooltip = action.payload.plungerTooltip;
        protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette
        return { ...state, ...{
             protocolSection: protocolSection
           } }
      
      case 'ON_MIX':
        currentPipette.mixed = action.payload.mixed;
        protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette
        return { ...state, ...{
             protocolSection: protocolSection
           } }

      case 'SET_PIPETTE_VOL':
          //Set the volume of the pipette
          if ((action.payload.volume >= currentPipette.minVol) && (action.payload.volume <= currentPipette.maxVol)) {

        

              currentPipette.volume = action.payload.volume
              //Lodash merge current pipette into pipettes array
              protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette
              return { ...state, ...{
             protocolSection: protocolSection
           } }
          } else {
              return state
          }

      case 'SET_TIP_ATTACHED':

          currentPipette.tipAttached = action.payload.attached

          if(action.payload.attached === false){
            currentPipette.prevSolution = {}
          }

          protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette
          return { ...state, ...{
             protocolSection: protocolSection
           } }

      case 'SET_TIP_USED':
          currentPipette.tipUsed = action.payload.used
          protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette
          return { ...state, ...{
             protocolSection: protocolSection
           } }

      case 'SET_PIPETTE_SOLUTION':

        
          currentPipette.solution = action.payload.solution
          currentPipette.solutionAlias = action.payload.solutionAlias
          currentPipette.fragments = action.payload.fragments

          if(action.payload.solution !== null){
            currentPipette.prevSolution = action.payload.solution
          }
          
          protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette
          return { ...state, ...{
             protocolSection: protocolSection
           } }

      case 'SET_PIPETTE_IMG':
          currentPipette.imgPath = action.payload.imgPath
          protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette
          return { ...state, ...{
             protocolSection: protocolSection
           } }

      case 'SET_PIPETTE_ANIMATING_OUT':
          currentPipette.animatingOut = action.payload.animatingOut
          protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette
          return { ...state, ...{
             protocolSection: protocolSection
           } }

      case 'SET_PIPETTE_CONTROLS_VISIBLE':

          // Make the current pipettes controls visible
          currentPipette.controlsVisible = action.payload.controlsVisible

          protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette
          return { ...state, ...{
             protocolSection: protocolSection
           } }

      case 'HIDE_ALL_CONTROLS':	
        // Hide the controls for all the other pipettes	
        protocolSection.scene.apparatus?.pipettes?.forEach((pipette) => {
          pipette.controlsVisible = false;
        })

        return { ...state, ...{
          protocolSection: protocolSection
        } }

      case 'SET_PIPETTE_PLUNGER_POSITION':
          currentPipette.plungerPosition = action.payload.plungerPosition
          protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette
          return { ...state, ...{
             protocolSection: protocolSection
           } }

      case 'SET_PIPETTE_CURRENT_PLUNGER_POSITION':
          currentPipette.currentPlungerPos = action.payload.currentPlungerPos
          protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette
          return { ...state, ...{
             protocolSection: protocolSection
           } }

      case 'SET_HELD':
          currentPipette.held = action.payload.held
          protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette
          return { ...state, ...{
             protocolSection: protocolSection
           } }

      case "UNDO":
          //Payload = {lastState}
          if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('pipettes')) {
            protocolSection.scene.apparatus.pipettes = action.payload.lastState.scene.apparatus.pipettes
            return { ...state, ...{
               protocolSection: protocolSection
            } }
           } else {
             return state;
           }

      default:
          return state;
    }
};